import { NewsItemType } from '../types';

export const newsItems: NewsItemType[] = [
  {
    id: '1',
    title: "MUBS Climate Finance Centre Leads Discussion at Uganda's CCDR Workshop",
    date: 'May 9, 2024',
    category: 'Featured Event',
    description: 'Dr. Maria Nantongo and the CFSC team contribute valuable insights at the World Bank-sponsored Country Climate Change and Development Report technical workshop.',
    image: '/images/CCDR-Event.jpg',
    slug: 'mubs-cfsc-ccdr-workshop',
    location: 'Kampala Sheraton Hotel',
    content: `
      <h2 class="text-xl font-semibold text-gray-900 mb-4">Key Highlights</h2>
      <ul class="space-y-3 text-gray-600 mb-6">
        <li>• Discussion of Uganda's climate finance landscape</li>
        <li>• Analysis of program-based solutions versus sector-specific approaches</li>
        <li>• Review of preliminary results from climate impact channel modeling</li>
        <li>• Examination of macro analytics and institutional analysis findings</li>
        <li>• Exploration of climate financing opportunities</li>
      </ul>

      <h2 class="text-xl font-semibold text-gray-900 mb-4">Workshop Context</h2>
      <p class="text-gray-600 mb-6">
        The World Bank's CCDR initiative has already completed over twenty reports covering more than 
        25 countries across sub-Saharan Africa. These reports emphasize the urgent need for enhanced 
        climate resilience and highlight opportunities in low-carbon development and green energy transitions.
      </p>

      <blockquote class="border-l-4 border-green-500 pl-4 italic text-gray-600 mb-6">
        "We appreciate the Ministry of Finance, Planning and Economic Development for involving us in 
        these crucial climate finance discussions, and MUBS Management for their continued support of 
        the Centre's operations." - Dr. Maria Nantongo
      </blockquote>
    `
  },
  {
    id: '3',
    title: 'Successful Conclusion of 1st Climate Finance Conference',
    date: 'September 20, 2023',
    category: 'Conference Highlights',
    description: 'The inaugural conference brought together stakeholders from across Africa to define climate finance priorities.',
    image: '/images/1st-Conference.jpg',
    slug: '1st-conference-conclusion',
    location: 'MUBS Conference Center',
    content: `
      <h2 class="text-xl font-semibold text-gray-900 mb-4">Conference Achievements</h2>
      <p class="text-gray-600 mb-6">
        The inaugural Africa Climate Finance Conference concluded successfully with over 200 participants 
        from 15 African countries. The three-day event featured intense discussions, knowledge sharing, 
        and strategic planning for climate finance initiatives across the continent.
      </p>

      <h2 class="text-xl font-semibold text-gray-900 mb-4">Key Outcomes</h2>
      <ul class="space-y-3 text-gray-600 mb-6">
        <li>• Establishment of the African Climate Finance Network</li>
        <li>• Launch of the Climate Finance Capacity Building Program</li>
        <li>• Development of regional climate finance guidelines</li>
        <li>• Creation of a climate project database</li>
      </ul>

      <blockquote class="border-l-4 border-green-500 pl-4 italic text-gray-600 mb-6">
        "This conference has laid a strong foundation for future collaboration in climate finance across Africa. 
        We are excited to build on these achievements in our future events." - Conference Organizing Committee
      </blockquote>
    `
  }
].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());